<template>
  <div class="main-navigation">
    <nav>
      <main-nav :pos_top="120">
        <div>
          <ul>
            <li v-if="isLoggedIn">
              <router-link to="/main/requests">Requests</router-link>
            </li>
            <li v-else>
              <router-link to="/auth/login">Login</router-link>
            </li>

            <li v-if="isLoggedIn">
              <base-button @click="logout"
                ><span>{{ user.nic }}</span> Logout
              </base-button>
            </li>
          </ul>
        </div>
      </main-nav>
    </nav>
  </div>
</template>
<script>
import MainNav from "@/components/nav/MainNav.vue";
export default {
  props: [],
  components: {
    MainNav,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    user() {
      return this.$store.getters.currentUser;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$flashMessage.show({
        type: "info",
        title: "로그아웃되었습니다",
        message: "",
      });
      //this.$router.replace('/');
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" >

.main-navigation {
  width: 100%;
  height: 5rem;
  background-color: #3d008d;
  background: #8E2DE2;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #3d008d, #720685);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #3d008d, #720685); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  display: flex;
  justify-content: center;
  align-items: center;
  font-family: malgungothic;
  font-size: 14px;
  box-shadow:  1px 1px 6px 0px rgba(0, 0, 0, 0.3);
  a {
    text-decoration: none;
    color: #ffffff;
    display: inline-block;
    padding: 0.75rem 1.5rem;
    //border: 1px solid transparent;
    font-size: 14px;
    font-family: malgungothic;
  }
  a:active,
  a:hover,
  a.router-link-active {
    border: 1px solid #f391e3;
    color: #f391e3;
  }

  h1 {
    margin: 0;
    a {
      color: white;
      margin: 0;
    }
    a:hover,
    a:active,
    a.router-link-active {
      border-color: transparent;
    }
  }
  nav {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
      .mainNav{
        width:890px;
        .navSpread{
            color:#7B63BA;
            z-index:2001;
        }
      }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  li {
    .nav_item {
      text-decoration: none;
      color: #ffffff;
      display: inline-block;
      padding: 0.75rem 0.9rem;
      border: 1px solid transparent;
      font-size: 16px;
      font-weight:bold;
      font-family: malgungothic;
    }
    .nav_item:hover
    {
      //border: 1px solid #f391e3;
      color: #f391e3;
    }
  }
}

</style>
